var React = require('react');

function Crop (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icoCrop"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icoCrop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M5.4472,14.039 L19.4752,14.039 L19.4752,15.761 L15.9472,15.761 L15.9472,19.289 L14.2252,19.289 L14.2252,15.761 L5.4472,15.761 C4.97119762,15.761 4.56520168,15.5930017 4.2292,15.257 C3.89319832,14.9209983 3.7252,14.5150024 3.7252,14.039 L3.7252,5.261 L0.1972,5.261 L0.1972,3.539 L3.7252,3.539 L3.7252,0.011 L5.4472,0.011 L5.4472,14.039 Z M14.2252,12.275 L14.2252,5.261 L7.2112,5.261 L7.2112,3.539 L14.2252,3.539 C14.7012024,3.539 15.1071983,3.70699832 15.4432,4.043 C15.7792017,4.37900168 15.9472,4.78499762 15.9472,5.261 L15.9472,12.275 L14.2252,12.275 Z","fill":"#FFFFFF"}))]);
}

Crop.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = Crop;

Crop.default = Crop;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/crop.svg
// module id = 930
// module chunks = 0